import React from 'react';
import './styles.scss';

interface ModeTabProps {
    active: boolean;
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    onClick: () => void;
}

const ModeTab = ({ active, icon, title, subtitle, onClick }: ModeTabProps) => (
    <button type="button" className={`rb-mode-tab ${active ? 'rb-mode-tab--active' : ''}`} onClick={onClick}>
        <span className="rb-mode-tab__icon">{icon}</span>
        <div className="rb-mode-tab__text">
            <span className="rb-mode-tab__title">{title}</span>
            <span className="rb-mode-tab__subtitle">{subtitle}</span>
        </div>
    </button>
);

export default ModeTab;
